export default function PHP_JSON() {
  return (
    <div>
      <h1>PHP_JSON</h1>
    </div>
  );
}
